<div class="login-container">
  <mat-card class="login-card">
    <h2>Ingreso administración</h2>

    <form [formGroup]="loginForm" (ngSubmit)="submit()">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Usuario</mat-label>
        <input matInput formControlName="username" autocomplete="username" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Contraseña</mat-label>
        <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password" autocomplete="current-password" />
        <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword">
          <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </mat-form-field>

      @if (errorMessage) {
        <div class="error-message">{{ errorMessage }}</div>
      }

      <button mat-flat-button color="primary" class="login-btn full-width" type="submit" [disabled]="loginForm.invalid || loading">
        {{ loading ? 'Ingresando...' : 'Ingresar' }}
      </button>
    </form>
  </mat-card>
</div>
